import { Controller } from "@hotwired/stimulus"

// Polls bulk_discover_status.json while a BulkDiscovery run is active.
// Same shape as the other GridSignal progress monitors.
export default class GsBulkDiscoveryMonitorController extends Controller {
  static targets = [
    "statusBadge", "progressBar",
    "processedCount", "totalCandidates",
    "foundValid", "notOnLegistar",
    "elapsedText", "currentStep"
  ]
  static values = { url: String, active: Boolean }

  connect() {
    if (this.activeValue) this.poll()
  }

  disconnect() {
    if (this._timer) clearTimeout(this._timer)
  }

  poll() {
    fetch(this.urlValue, { headers: { "Accept": "application/json" } })
      .then(r => r.json())
      .then(data => this.update(data))
      .catch(() => {})
      .finally(() => {
        if (this.activeValue) {
          this._timer = setTimeout(() => this.poll(), 2000)
        }
      })
  }

  update(data) {
    if (data.status === "none") return

    if (this.hasStatusBadgeTarget) {
      this.statusBadgeTarget.textContent = this.capitalize(data.status)
      this.statusBadgeTarget.className = `status-badge status-${data.status}`
    }
    if (this.hasProgressBarTarget) {
      this.progressBarTarget.style.width = `${data.progress_percentage}%`
    }
    if (this.hasProcessedCountTarget) this.processedCountTarget.textContent = data.processed_count
    if (this.hasTotalCandidatesTarget) this.totalCandidatesTarget.textContent = data.total_candidates
    if (this.hasFoundValidTarget) this.foundValidTarget.textContent = data.found_valid
    if (this.hasNotOnLegistarTarget) this.notOnLegistarTarget.textContent = data.not_on_legistar
    if (this.hasElapsedTextTarget && data.elapsed_seconds != null) {
      this.elapsedTextTarget.textContent = `${data.elapsed_seconds}s`
    }
    if (this.hasCurrentStepTarget && data.current_step) {
      this.currentStepTarget.textContent = data.current_step
    }

    if (data.status === "completed" || data.status === "failed") {
      this.activeValue = false
      setTimeout(() => window.location.reload(), 800)
    }
  }

  capitalize(str) {
    return str ? str.charAt(0).toUpperCase() + str.slice(1) : ""
  }
}
